import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import BaseModal from "./BaseModal";
import Grid from "@mui/material/Grid";
import { Alert, MenuItem } from "@mui/material";
import { TextInputContainer } from "../forms/TextInput";
import SessionTypeSelect from "components/forms/SessionTypeSelect";
import { formatSessionTypes, parseSessionTypes } from "services/RankingFilterHelper";

export default function EditSessionTypeAndClusterModal({ open, onClose, onSubmit, infoMessage, warningMessage, customField = [] }) {

    const { t } = useTranslation();
    let [sessionTypeVal, setSessionTypeVal] = useState([]);
    let [customFieldVal, setCustomFieldVal] = useState();
    let [error, setError] = useState({});

    function submit() {
        if (parseSessionTypes(sessionTypeVal).length === 0) {
            setError({ sessionTypeVal: t('mandatoryField') })
            return
        }
        if (customFieldVal == null || customFieldVal == undefined) {
            setError({ customFieldVal: t('mandatoryField') })
            return
        }
        onSubmit(formatSessionTypes(sessionTypeVal) + " - " + customFieldVal);
        setError({});
        setSessionTypeVal([])
        setCustomFieldVal(null)
        onClose();
    }

    return <BaseModal open={open} onClose={onClose} onSave={submit}>
        {infoMessage &&
            <Grid item xs={12} style={{ marginBottom: "0.5rem", padding: "16px" }}>
                <Alert variant="outlined" severity="info">{infoMessage}</Alert>
            </Grid>
        }
        {warningMessage &&
            <Grid item xs={12} style={{ marginBottom: "0.5rem", padding: "16px" }}>
                <Alert variant="outlined" severity="warning">{warningMessage}</Alert>
            </Grid>
        }
        <Grid container spacing={4} style={{ margin: 0, width: "100%", marginBottom: "1rem" }}>

            <SessionTypeSelect xs={6} label={t('sessionType')} value={sessionTypeVal}
                onTextChange={(value) => { setSessionTypeVal(value); setError({}) }}
                error={error.sessionTypeVal} />

            <TextInputContainer xs={6} required label={t('customField')} value={customFieldVal}
                options={customField} select
                onTextChange={(value) => setCustomFieldVal(value)}
                error={error.customFieldVal}>
                {customField.map(o => <MenuItem key={o.id} value={o.id}>{o.name}</MenuItem>)}
            </TextInputContainer>

            <div style={{ width: "15rem" }} />
        </Grid>
    </BaseModal>
}